import candsLogo from "/img/integration/cands.png"
import { ConnectIntegrationForm } from "../connect-integration-form"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function ConnectCandsPage(props: any = {}) {
  const redirectTo: string = props.redirectTo ?? "/setup/connect/cands-dispute-portal"

  return (
    <ConnectIntegrationForm
      integrationName="cands"
      redirectTo={redirectTo}
      logoSrc={candsLogo}
      logoAlt="C&S"
      description="Enter your C&S vendor portal credentials. We sign in every weekday and pull your Check Cover Sheets report, so you don't have to upload it."
    />
  )
}
